import React from 'react';
import ProfileForm, { PROFILE_MODES } from '../profile-form';

/**
 * Edit Profile Page
 * 
 * Thin wrapper around the unified ProfileForm component
 * configured for editing existing profiles.
 */
const EditProfile = () => {
  return <ProfileForm mode={PROFILE_MODES.EDIT} />;
};

export default EditProfile;
